import { FC, HTMLAttributes } from 'react'
import Filters from './Filters'
import Icon from '../elements/Icon'
import SortBy from './SortBy'
import { useStoreState } from '@/store'

interface Props extends HTMLAttributes<HTMLDivElement> {
  visible: boolean
  onClose: () => void
}

const MobileFilters: FC<Props> = ({ className, visible, onClose }) => {
  const { dimensionsInvalid } = useStoreState(state => state.search)

  return (
    <div className={className}>
      <div
        data-testid="mobile-filter-modal"
        className={`MobileFilters Modal fixed overflow-hidden p-0 ${
          visible ? 'active' : ''
        }`}
      >
        <div className="Modal-overlay"></div>

        <div className="Modal-container w-full flex-col">
          <div className="Modal-container-header bg-white rounded-t-lg shadow-sm z-5 overflow-hidden px-4 py-5 flex justify-between items-center">
            <div className="m-0 type-heading-six uppercase">Filters</div>
            <button
              type="button"
              className="Button leading-none p-0"
              onClick={onClose}
              data-testid="mobile-filter-close-btn"
            >
              <Icon variant="close" className="Icon--xs" />
            </button>
          </div>

          <div className="Modal-container-body bg-white grow overflow-auto p-4">
            <SortBy className="mb-6" />
            <Filters />
          </div>

          <div className="Modal-container-footer bg-white z-5 overflow-hidden text-center p-4">
            <button
              className="Button Button--primary Button--small w-full"
              onClick={onClose}
              data-testid="mobile-filter-update-btn"
              disabled={dimensionsInvalid}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileFilters
